<template>
	<div class="about">
		<Header :type="pageType" />
		<div class="banner banner_about"></div>
		<div class="content clearfix">
			<ul class="tabs">
				<li
					v-for="tab in tabs"
					:key="tab.id"
					:class="['tab', current == tab.id ? 'active2' : '']"
					@click="onChange(tab.id)"
				>
					<i class="disc"></i>{{ tab.name }}
				</li>
			</ul>
			<div class="main_content">
				<template v-if="current === 41">
					<div class="description about_description clearfix">
						<div class="card">
							<img
								src="@/assets/images/version/about1.png"
								class="card_banner"
								alt="骆驼简介"
							/>
							<div class="card_content">
								<div class="title_level1 title_level1_2">
									骆驼简介
								</div>
								<p>
									骆驼规划是润安国际保险经纪有限公司的核心品牌，拥有中国银行保险监督管理委员会颁发的经营保险经纪业务许可证，是一家专业中立的第三方保障规划平台，致力于让普通家庭也能享受到量身定制的保障规划服务。
								</p>
							</div>
						</div>
						<div class="card">
							<img
								src="@/assets/images/version/about2.png"
								class="card_banner"
								alt="我们的愿景"
							/>
							<div class="card_content">
								<div class="title_level1 title_level1_2">
									我们的愿景
								</div>
								<p style="margin-bottom:8px">
									成为值得信赖的第三方保障规划平台
								</p>
								<p>
									骆驼规划坚持“用科学的理念辅助保险决策”，依托大数据、云计算和人工智能开发的方案配置系统，帮助用户实现家庭风险量化、精准产品匹配；通过精算、核保、理赔、法律等专业支持，为用户提供高效、省心的全流程服务。
								</p>
							</div>
						</div>
						<div class="card card_bg">
							<img
								src="@/assets/images/version/about3.png"
								class="card_banner"
								alt="我们的团队"
							/>
							<div class="card_content">
								<div class="title_level1 title_level1_2">
									<div class="icon"></div>
									我们的团队
								</div>
								<p style="margin-bottom:8px;">
									我们有一支资深的顾问专家团队，真正从用户角度出发，客观向用户推荐适合他们的产品。也有来自知名互联网公司的技术专家，用大数据、云计算和人工智能帮助用户科学配置保障方案；还有来自精算、核保、法律等领域的资深专家，利用自身的专业知识，通俗易懂地为用户讲解保险知识，帮助用户轻松做出选择。
								</p>
								<p>
									聚集优秀的人才做优秀的事情，用专业、中立的视角普及保险理念，让普通人也能获得量身定制的科学保障规划，人生路上没有后顾之忧。
								</p>
							</div>
						</div>
					</div>
				</template>
				<template v-if="current === 42">
					<div class="description">
						<div class="title_level1 title_level1_2">
							<div class="icon"></div>
							保监许可
						</div>
						<p>
							骆驼规划是润安国际保险经纪有限公司的核心品牌，拥有中国保险监督管理委员会颁发的经营保险经纪业务许可证，是一家专业中立的第三方保障规划平台。
						</p>
						<p>
							查询地址：http://iir.circ.gov.cn/
						</p>
						<div class="img_border">
							<img src="@/assets/images/version/about4.png" alt="保监许可"/>
						</div>
						<div class="title_level1 title_level1_2">
							<div class="icon"></div>
							营业执照
						</div>
						<div class="img_border">
							<img src="@/assets/images/version/about5.jpg" alt="营业执照"/>
						</div>
					</div>
				</template>
				<template v-if="current === 43">
					<div class="description">
						<div class="img_border border_text">
							<div>
								Tel: 400-099-9559
							</div>
							<div>
								地址：江西省南昌市东湖区阳明东路66号央央春天投资大厦12层03室
							</div>
						</div>
						<div class="img_border border_bg">
							<img src="@/assets/images/version/about61.png" alt="地址"/>
						</div>
					</div>
				</template>
			</div>
		</div>
		<tools :type="current" />
		<Footer :type="current" />
	</div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Tools from '@/components/absoluteTools';
export default {
	layout: 'baseLayout',
	metaInfo() {
	    return {
	      title: '骆驼规划官网-润安国际保险-专业保险规划机构，省心省钱买对保险',
	      keywords: '骆驼规划,保险方案,保险评测,保险理赔',
	      description: '骆驼规划是一家专业中立的第三方保险规划平台，致力于让普通家庭也能享受到量身定制的保险规划服务，提供包括重疾险、医疗险、儿童险、寿险、意外险等在内的保险方案定制、风险评测、理赔协助、保险科普、保险评测等服务。'
	    };
	},
	data() {
		return {
			pageType: 4,
			current: parseInt(this.$route.params.id || 41),
			tabs: [
				{
					name: '关于我们',
					id: 41
				},
				// {
				// 	name: '公司资质',
				// 	id: 42
				// },
				// {
				// 	name: '联系我们',
				// 	id: 43
				// }
			],
			url: '',
      path: '',
			title: '',
			keywords: '',
			description: ''
		};
	},
	name: 'Information',
	components: {
		Header,
		Footer,
		Tools
	},
	mounted() {
		document.body.style.backgroundColor = '#F9FAFF';
	},
	methods: {
		onChange (id) {
			this.$router.push({
				path: `/about/${id}`
			})
		}
	}
};
</script>
